<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<app-experiment-nagivator [experimentToView]="experimentToView" [action]="action"
  *ngIf="experimentToView && action"/>
<div *ngIf="experimentToView && tasksToView" class="view-exp">
  <ng-container *ngIf="hasOnlyOneTask(); else displayBothCausalImpactAndDidTasks">
    <app-experiment-and-task-details [experiment]="experimentToView" [task]="tasksToView[0]"/>
    <div class="view-experiment-parameters">
      <app-splitting-input-files-and-parameters *ngIf="canDisplaySplittingParameters()"
        [splittingParameters]="extractSplittingParameters()"
        [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(0)"
        [configFileInfo]="extractConfigFile()"/>
      <app-budget-simulation-input-files-and-parameters *ngIf="canDisplayBudgetSimulationParameters()"
          [budgetSimulationParameters]="extractBudgetTableParameter()"
          [kpiFileInfo]="extractKPIFileForBudgetSimulation()"
          [startingPoint]="this.experimentToView.startingPoint"
          [selectedPlan]="selectedPlans[0]"/>
      <app-impact-measurement-input-files-and-parameters
          *ngIf="canDisplayCausalImpactAnalysisParameters()"
          [analysisParameters]="extractCausalImpactAnalysisParameters()"
          [startingPoint]="this.experimentToView.startingPoint"
          [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(0)"
          [taskType]="tasksToView[0].taskType"
          [selectedPlan]="selectedPlans[0]"/>
      <app-impact-measurement-input-files-and-parameters *ngIf="canDisplayDidAnalysisParameters()"
          [analysisParameters]="extractDidAnalysisParameters()"
          [startingPoint]="this.experimentToView.startingPoint"
          [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(0)"
          [taskType]="tasksToView[0].taskType"
          [selectedPlan]="selectedPlans[0]"/>
    </div>
    <div class="view-results">
      <app-experiment-results [experimentId]="experimentToView.id"[task]="tasksToView[0]"/>
    </div>
  </ng-container>
  <ng-template #displayBothCausalImpactAndDidTasks>
    <mat-tab-group color="accent" *ngIf="isFirstTaskTypeCausalImpact(tasksToView[0])">
      <mat-tab label="Causal Impact" i18n-label>
        <div class="causal-impact-header"></div>
        <app-experiment-and-task-details [experiment]="experimentToView" [task]="tasksToView[0]"/>
        <div class="view-experiment-parameters">
          <app-impact-measurement-input-files-and-parameters
            *ngIf="canDisplayCausalImpactAnalysisParameters()"
            [analysisParameters]="extractCausalImpactAnalysisParameters()"
            [startingPoint]="this.experimentToView.startingPoint"
            [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(0)"
            [taskType]="tasksToView[0].taskType"
            [selectedPlan]="selectedPlans[0]"/>
        </div>
        <div class="view-results">
          <app-experiment-results [experimentId]="experimentToView.id" [task]="tasksToView[0]"/>
        </div>
      </mat-tab>
      <mat-tab label="Difference-in-Differences" i18n-label>
        <div class="difference-in-differences-header"></div>
        <app-experiment-and-task-details [experiment]="experimentToView" [task]="tasksToView[1]"/>
        <div class="view-experiment-parameters">
          <app-impact-measurement-input-files-and-parameters
            *ngIf="canDisplayDidAnalysisParameters()"
            [analysisParameters]="extractDidAnalysisParameters()"
            [startingPoint]="this.experimentToView.startingPoint"
            [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(1)"
            [taskType]="tasksToView[1].taskType"
            [selectedPlan]="selectedPlans[1]"/>
        </div>
        <div class="view-results">
          <app-experiment-results [experimentId]="experimentToView.id" [task]="tasksToView[1]"/>
        </div>
      </mat-tab>
    </mat-tab-group>
    <mat-tab-group color="accent" *ngIf="!isFirstTaskTypeCausalImpact(tasksToView[0])">
      <mat-tab label="Difference-in-Differences" i18n-label>
        <app-experiment-and-task-details [experiment]="experimentToView" [task]="tasksToView[0]"/>
        <div class="view-experiment-parameters">
          <app-impact-measurement-input-files-and-parameters
            *ngIf="canDisplayDidAnalysisParameters()"
            [analysisParameters]="extractDidAnalysisParameters()"
            [startingPoint]="this.experimentToView.startingPoint"
            [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(0)"
            [taskType]="tasksToView[0].taskType"
            [selectedPlan]="selectedPlans[0]"/>
        </div>
        <div class="view-results">
          <app-experiment-results [experimentId]="experimentToView.id" [task]="tasksToView[0]"/>
        </div>
      </mat-tab>
      <mat-tab label="Causal Impact" i18n-label>
        <app-experiment-and-task-details [experiment]="experimentToView" [task]="tasksToView[1]"/>
        <div class="view-experiment-parameters">
          <app-impact-measurement-input-files-and-parameters
            *ngIf="canDisplayCausalImpactAnalysisParameters()"
            [analysisParameters]="extractCausalImpactAnalysisParameters()"
            [startingPoint]="this.experimentToView.startingPoint"
            [kpiFileInfo]="extractKPIFileForSplittingOrImpactMeasurement(1)"
            [taskType]="tasksToView[1].taskType"
            [selectedPlan]="selectedPlans[1]"/>
        </div>
        <div class="view-results">
          <app-experiment-results [experimentId]="experimentToView.id" [task]="tasksToView[1]"/>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-template>
</div>
